import { render } from "./Dashboard.vue?vue&type=template&id=300d3310&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=300d3310&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dyamd\\OneDrive\\Documents\\PROYECTOS\\ceramicas\\mi-stock-ceramicas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300d3310"]])

export default __exports__